import Radio from '@ixigo/iui/Radio';
import Typography from '@ixigo/iui/Typography';
import { useEffect, useState } from 'react';
import { TestId } from '../../enums/test';
import { ListItem, RadioListProps } from './index.types';

function RadioList({ data, onChange }: RadioListProps) {
    const [selection, setSelection] = useState<ListItem>();

    useEffect(() => {
        onChange(selection);
    }, [selection]);

    return (
        <div className='flex flex-col gap-0.5' data-testid={TestId.RADIO_LIST}>
            {data.map((item, index) => (
                <div
                    key={item.id}
                    className='flex items-center gap-5 p-5'
                    onClick={() => setSelection(item)}
                    data-testid={`${TestId.RADIO_WRAPPER}${index}`}
                >
                    <Radio
                        checked={selection?.id === item.id}
                        className='m-0.5'
                        data-testid={`${TestId.RADIO}${index}`}
                    />
                    <Typography variant='body-md'>{item.label}</Typography>
                </div>
            ))}
        </div>
    );
}

export default RadioList;
